import { Component } from '@angular/core';
import { EventService, OrganisationsService, TelephonyService } from '../../../services';
import { OrganisationSelectorEventTypeEnum } from '../../../interfaces/telephony/organisation-selector-event-type.enum';
import { IOrganisationSelectorEvent } from '../../../interfaces/telephony/organisation-selector-event';
import { IBasicOrganisationInfo } from '../../../interfaces/telephony/basic-organisation-info';
import { IBasicUser } from '../../../interfaces/telephony/basic-user.dto.interface';
import { ICallerInfo } from '../../../interfaces/telephony/caller-info';
import { IOrganisationPhoneNumber } from '../../../interfaces/telephony/organisation-phone-number';
import { MessageService } from 'primeng';
import { Message } from '../../../classes/Message';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'add-number-to-organisation',
  templateUrl: './add-number-to-organisation.component.html',
  styleUrls: ['./add-number-to-organisation.component.scss'],
})
export class AddNumberToOrganisationComponent {
  constructor(
    private eventService: EventService,
    private telephonyService: TelephonyService,
    private organisationService: OrganisationsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {
    this.eventService.OrganisationSelectorEvent.subscribe((event: IOrganisationSelectorEvent) => {
      //console.log("SELECTOR EVENT: ", event);

      if (event.eventType == OrganisationSelectorEventTypeEnum.OpenAddNumberSelector) {
        this.orgSelectorVisible = true;
        this.callerInfo = telephonyService.CurrentCallState$.value?.callerInfo;
      }
      if (event.eventType == OrganisationSelectorEventTypeEnum.AddNumberSelectorClosed) {
        this.orgSelectorVisible = false;
      }
      if (event.eventType == OrganisationSelectorEventTypeEnum.AssociateOrganisationSelected) {
        this.selectedOrg = event.args.selectedOrg;
        this.selectedUser = null;
      }
      if (event.eventType == OrganisationSelectorEventTypeEnum.AssociateUserSelected) {
        this.selectedOrg = event.args.selectedOrg;
        this.selectedUser = event.args.selectedUser;
      }
    });
  }

  orgSelectorVisible = false;
  callerInfo: ICallerInfo;
  selectedOrg: IBasicOrganisationInfo;
  selectedUser: IBasicUser;

  cancel() {
    this.eventService.OrganisationSelectorEvent.emit({
      eventType: OrganisationSelectorEventTypeEnum.AddNumberSelectorClosed,
    });
  }

  async addNumber() {
    //console.log('ADD NUMBER ORG: ', this.selectedOrg);
    //console.log('ADD NUMBER USER: ', this.selectedUser);

    let dto = {
      organisationId: this.selectedOrg.id,
      userId: this.selectedUser?.id,
      phoneNumber: this.callerInfo.phoneNumber,
    } as IOrganisationPhoneNumber;

    this.telephonyService
      .setOrganisationPhoneNumber(dto)
      .then(() => {
        // telephony control will pickup this event and change the tab display accordingly
        this.eventService.OrganisationSelectorEvent.emit({
          eventType: OrganisationSelectorEventTypeEnum.AddNumberSelectorClosed,
          args: { selectedOrg: this.selectedOrg, selectedUser: this.selectedUser },
        });

        this.messageService.add(
          Message.Success('Phone number added to selected organisation', 'Number Added'),
        );
      })
      .catch((err) => {
        console.log('Error: ', err);
        this.messageService.add(
          Message.Success('An error occurred saving the organisation phone number', 'Error'),
        );
      });
  }
}
